export const PROJECT_VIEW_TABS = {
  ISSUES: 'issues',
  TEMPLATES: 'templates'
};

export const PreviewNavigationTabIds = {
  DETAILS: 'details',
  ATTACHMENTS: 'attachments',
  ACTIVITY: 'activity'
};
